import React, { useState } from 'react';
import { Alert, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useOrderListingHintStore } from 'utils/orderListingHintTracker';

/**
 * 订单列表 / 异常列表 Filter 顶部自适应提示：
 * 默认隐藏；用户 5 分钟内触发 ≥ 2 次后端 guard 拦截才显示，显示后保持到刷新页面。
 * 显示后用户可手动收起规则面板。
 */
const OrderListingQueryHint: React.FC = () => {
    const { t } = useTranslation();
    const visible = useOrderListingHintStore((s) => s.visible);
    const [expanded, setExpanded] = useState(true);

    if (!visible) return null;

    const ruleSections = ['main', 'aux', 'window'];
    const description = expanded ? (
        <div>
            {ruleSections.map((section, idx) => (
                <React.Fragment key={section}>
                    <p className="mb-1"><strong>{t(`errors.business.order.listingQueryRules.${section}Title`)}</strong></p>
                    <p className={idx === ruleSections.length - 1 ? 'mb-0' : 'mb-2'}>
                        {t(`errors.business.order.listingQueryRules.${section}List`)}
                    </p>
                </React.Fragment>
            ))}
        </div>
    ) : null;

    return (
        <Alert
            type="info"
            showIcon
            className="mb-3"
            message={t('errors.business.order.listingQueryHint')}
            description={description}
            action={
                <Typography.Link onClick={() => setExpanded(!expanded)}>
                    {expanded ? t('errors.business.order.listingQueryRules.collapse') : t('errors.business.order.listingQueryRules.expand')}
                </Typography.Link>
            }
        />
    );
};

export default OrderListingQueryHint;
